import moment from 'moment'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { getSzansa } from '../../details/rozmowaDetailsHelpers'

const getRelationId = relation => {
	if (!relation) return ''
	if (typeof relation === 'object') return relation?._id || relation?.id || ''
	return relation
}

const looksLikeObjectId = value => /^[a-fA-F0-9]{24}$/.test(String(value))

const getRelationValue = relation => {
	if (!relation) return '-'
	if (typeof relation === 'string') return looksLikeObjectId(relation) ? '-' : relation
	if (typeof relation !== 'object') return String(relation)

	return relation.nazwa || relation.typ || relation.imie_i_nazwisko || relation.alternative_name || relation.name || '-'
}

const formatDateTime = value => {
	if (!value) return '-'
	return moment(value).isValid() ? moment(value).format('YYYY-MM-DD HH:mm') : '-'
}

export default function RozmowyTableRow({ rozmowa }) {
	const { t } = useTranslation()
	const placowka = rozmowa?.id_placowka || rozmowa?.placowka
	const rozmowaId = rozmowa?._id || rozmowa?.id
	const osobaId = getRelationId(rozmowa?.id_osoba || rozmowa?.osoba)
	const placowkaId = getRelationId(placowka)
	const osobaName = rozmowa?.imie_i_nazwisko || getRelationValue(rozmowa?.id_osoba || rozmowa?.osoba)
	const placowkaName = rozmowa?.placowkaName || rozmowa?.placowka_nazwa || getRelationValue(placowka)
	const userName = getRelationValue(rozmowa?.id_user)
	const conversationDate = formatDateTime(rozmowa?.dig_rozmowy)
	const isSalesOpportunity = getSzansa(rozmowa)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{rozmowaId ? (
					<Link
						to={`/komunikacja/rozmowy/details/${rozmowaId}`}
						className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
						{conversationDate}
					</Link>
				) : (
					<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-black">
						{conversationDate}
					</span>
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-black">
					{formatDateTime(rozmowa?.dig_nastepnej_rozmowy)}
				</span>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{osobaId ? (
					<Link
						to={`/klienci/osoba/details/${osobaId}`}
						className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
						{osobaName}
					</Link>
				) : (
					osobaName
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{isSalesOpportunity ? (
					<span className="inline-flex items-center rounded-full bg-green-50 px-2.5 py-0.5 text-xs font-medium text-green-700">
						{t('conversations.list.filters.salesOpportunityYes')}
					</span>
				) : (
					<span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
						{t('conversations.list.filters.salesOpportunityNo')}
					</span>
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{placowkaId ? (
					<Link
						to={`/klienci/placowki/details/${placowkaId}`}
						className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
						{placowkaName}
					</Link>
				) : (
					placowkaName
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">{userName}</td>
		</tr>
	)
}
